import { Link } from "react-router-dom";

const T = "#2dd4bf";

const S = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="text-lg md:text-lg font-bold text-white mb-3" style={{ color: T }}>{title}</h2>
    <div className="text-neutral-400 text-sm leading-relaxed space-y-3">{children}</div>
  </section>
);

export default function Privacy() {
  return (
    <div className="min-h-screen text-white" style={{ background: "#090c0c" }} data-testid="privacy-page">
      <header className="border-b border-neutral-900 px-8 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="privacy-logo-link">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ background: T }}>
            <span className="text-black text-lg font-bold">▶</span>
          </div>
          <div>
            <div className="text-white font-bold text-lg leading-tight">Watermark Batch Pro</div>
            <div className="text-neutral-500 text-xs">Advanced Batch Video Watermarker for Mac</div>
          </div>
        </Link>
        <Link to="/" className="text-neutral-400 text-sm hover:text-white" data-testid="privacy-back-link">← Back to site</Link>
      </header>

      <main className="max-w-3xl mx-auto px-8 py-14">
        <h1 className="text-4xl sm:text-5xl font-bold mb-3" data-testid="privacy-title">Privacy Policy</h1>
        <p className="text-neutral-500 text-sm mb-12">
          Product: Watermark Batch Pro &nbsp;·&nbsp; Website:{" "}
          <a href="https://watermarkbatchpro.com" className="underline hover:text-white">https://watermarkbatchpro.com</a>
          &nbsp;·&nbsp; Effective date: August 27, 2026
        </p>

        <S title="Overview">
          <p>
            Watermark Batch Pro is a local desktop video-processing app for Mac. It adds
            watermarks, blurs and crops to your videos entirely on your own computer.
            The app has no account system, no login, and no server component. This policy
            explains what that means for your privacy.
          </p>
        </S>

        <S title="Information We Collect">
          <p>
            <span className="text-white font-semibold">The Mac app collects no personal
            information.</span> It does not require an account or login, does not contain
            analytics or telemetry, and does not transmit any data about you or your usage
            to us or to anyone else.
          </p>
          <p>
            If you choose to contact us by email, we receive your email address and the
            contents of your message, which we use only to respond to you.
          </p>
        </S>

        <S title="How the App Processes Files">
          <p>
            All video and watermark processing happens locally on your Mac. Videos,
            watermark images and text you select are read and written only on your
            computer, in the locations you choose. Your files are never uploaded to our
            servers or to any third party.
          </p>
          <p>
            Your watermark presets and settings are stored locally on your Mac and never
            leave it. The Mac App Store version runs inside Apple's App Sandbox, which
            restricts the app to only the files and folders you explicitly select.
          </p>
        </S>

        <S title="Data Sharing">
          <p>
            We do not sell user data. We do not share user data with third parties. We do
            not use advertising networks or advertising tracking, and we do not track users
            across apps or websites.
          </p>
          <p>
            If you purchased the app through the Mac App Store, the purchase is handled
            entirely by Apple under{" "}
            <a href="https://www.apple.com/legal/privacy/" className="underline hover:text-white"
               target="_blank" rel="noreferrer">Apple's Privacy Policy</a>. We never see
            your payment details.
          </p>
        </S>

        <S title="Data Retention">
          <p>
            Because the app collects no data, there is nothing for us to retain. Files and
            presets the app creates live only on your Mac, under your control, and can be
            deleted by you at any time. Support emails are kept only as long as needed to
            resolve your request.
          </p>
        </S>

        <S title="Security">
          <p>
            Your videos never leave your computer, which is the strongest protection
            available. The Mac App Store version is sandboxed and code-signed, and is
            reviewed and distributed by Apple.
          </p>
        </S>

        <S title="Children's Privacy">
          <p>
            Watermark Batch Pro does not collect personal information from anyone,
            including children. The app is a general-purpose video tool and is not
            directed at children under 13.
          </p>
        </S>

        <S title="Changes to This Policy">
          <p>
            If we ever change how the app handles data, we will update this page and revise
            the effective date above. Continued use of the app after a change means you
            accept the updated policy.
          </p>
        </S>

        <S title="Contact">
          <p>
            Questions about this policy or your privacy? Email us at{" "}
            <a href="mailto:support@watermarkbatchpro.com" className="underline hover:text-white"
               data-testid="privacy-contact-email">support@watermarkbatchpro.com</a>{" "}
            — we reply within 24 hours.
          </p>
        </S>
      </main>

      <footer className="border-t border-neutral-900 px-8 py-6 text-center text-neutral-600 text-xs">
        © 2026 Watermark Batch Pro. All rights reserved.
      </footer>
    </div>
  );
}
